module.exports = {
  title: "易和仓库系统"
};
